import SEO_PATHS from './seoRoutes';
import { SortingOptions } from '@zocdoc/branding/constants';

export { default as ENTRY } from './entry';

export const PATH = '/search';
export const PRACTICE_PATH = '/practice';
export const BasePaths = [PATH, PRACTICE_PATH, ...SEO_PATHS];

export const pageName = 'Search';

export const SEARCH_GA_CATEGORY = 'Search';

export const CookieNames = {
    address: 'address_cookie',
    healthCarrierId: 'hCarrierId',
    healthPlanId: 'hPlanId',
};

export const SearchParameterToQuery = {
    address: 'address',
    carrierId: 'insurance_carrier',
    dayFilter: 'day_filter',
    directoryId: 'directory_id',
    excludeSpecialties: 'exclude_specialties',
    filters: 'filters',
    genderFilter: 'gender',
    ip: 'ip',
    languageId: 'language',
    latitude: 'latitude',
    longitude: 'longitude',
    mockSearchGql: 'mockSearchGql',
    name: 'name',
    pageOffset: 'offset',
    planId: 'insurance_plan',
    practiceId: 'practiceId',
    procedureId: 'reason_visit',
    searchQuery: 'search_query',
    showProvidersWhoSeeChildren: 'sees_children',
    showTimesAfter5: 'after_5pm',
    showTimesBefore10: 'before_10am',
    sortType: 'sort_type',
    specialtyId: 'dr_specialty',
    testSpoServiceDirect: 'test_spo_service_direct',
};

export const DayFilterEnum = {
    AnyDay: 'AnyDay',
    Today: 'Today',
    Next3Days: 'Next3Days',
};

export const GenderFilterEnum = {
    AnyGender: '-1',
    Male: '1',
    Female: '2',
};

export const SortingEnum = {
    [SortingOptions.Availability]: {
        name: 'onlinebookability',
        value: 'OnlineBookability',
        text: 'availability',
    },
    [SortingOptions.Default]: {
        name: 'default',
        value: 'Default',
        text: 'default order',
    },
    [SortingOptions.Distance]: {
        name: 'distance',
        value: 'Distance',
        text: 'distance',
    },
    [SortingOptions.WaitTime]: {
        name: 'waittime',
        value: 'WaitTimeRating',
        text: 'wait time rating',
    },
};

export const Defaults = {
    dayFilter: DayFilterEnum.AnyDay,
    genderFilter: GenderFilterEnum.AnyGender,
    languageId: '-1',
    procedureId: '-1',
    showProvidersWhoSeeChildren: false,
    showTimesAfter5: false,
    showTimesBefore10: false,
    sortType: SortingEnum[SortingOptions.Default].value,
};
